export default __webpack_public_path__ + "static/media/homebuyer-hero.1cc342be.jpg";